import React, { useEffect, useRef, useState } from 'react';
import { API_BASE_URL } from '../config';
import loaderImg from '../assets/loading.gif';
import axios from 'axios';
import { motion } from 'framer-motion';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import imgLogoSG from '../assets/logoSG2.png';

function Images() {
	const [dataGallery, setDataGallery] = useState({
		items: [],
		countAll: 0,
	});
	const [loading, setLoading] = useState(false);

	const count = useRef(0); // page_index
	const year = useRef(2025);
	const totalPages = useRef(0);

	const fetchDataGallery = async (selectYear, page_index) => {
		if (loading) return; // ✅ chặn spam
		if (totalPages.current && page_index > totalPages.current) return; // ✅ hết trang thì dừng

		setLoading(true);

		const params = {
			year: selectYear,
			page_index: page_index,
			page_size: 20,
		};

		const headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
		};

		try {
			const response = await axios.post(
				`${API_BASE_URL}hinhanh`,
				params,
				{ headers }
			);

			// ✅ SET TỔNG SỐ TRANG
			totalPages.current = Math.floor(response.data.countAll / 20);

			// ✅ APPEND DATA – KHÔNG GHI ĐÈ
			setDataGallery((prev) => ({
				...response.data,
				items: [...prev.items, ...response.data.items],
			}));
		} catch (err) {
			console.log('Err', err);
		}

		setLoading(false);
	};

	// ✅ Load lần đầu
	useEffect(() => {
		fetchDataGallery(year.current, 0);
	}, []);

	// ✅ Scroll tới cuối trang → load thêm
	useEffect(() => {
		const onScroll = () => {
			const isBottom =
				window.innerHeight + window.scrollY >=
				document.documentElement.scrollHeight - 10;

			if (isBottom && !loading) {
				count.current += 1;
				fetchDataGallery(year.current, count.current);
			}
		};

		window.addEventListener('scroll', onScroll);
		return () => window.removeEventListener('scroll', onScroll);
	}, [loading]);

	return (
		<div
			id='images'
			className='lg:mt-10 mt-5 lg:px-48 text-white lg:text-3xl text-3xl w-full scroll-mt-[100px]'
		>
			<div className='flex items-center gap-2'>
				<span>
					<img src={imgLogoSG} alt='' width={32} />
				</span>
				<h2>HÌNH ẢNH</h2>
			</div>

			<div className='lg:mt-10 mt-5'>
				{dataGallery.items.length === 0 ? (
					<div>
						<img
							src={loaderImg}
							alt='Loading...'
							className='mx-auto mt-10'
						/>
					</div>
				) : (
					<>
						<div className='grid grid-cols-2 lg:grid-cols-5 gap-3 w-full'>
							{dataGallery.items.map((item, index) => (
								<Zoom key={index}>
									<motion.img
										src={item.tvh_hinhanh}
										alt={item.tvh_mota}
										initial={{ opacity: 0, scale: 1.05 }}
										whileInView={{ opacity: 1, scale: 1 }}
										transition={{ duration: 0.6 }}
										viewport={{ once: true }}
										className='lg:w-[300px] lg:h-[200px] object-cover rounded-xl'
									/>
								</Zoom>
							))}
						</div>

						{/* ✅ LOADING KHI ĐANG LOAD TRANG MỚI */}
						{loading && (
							<div className='text-center mt-6 text-sm text-slate-400'>
								Đang tải thêm hình ảnh...
							</div>
						)}
					</>
				)}
			</div>
		</div>
	);
}

export default Images;
